import { styled, ListItem, listItemIconClasses, listItemButtonClasses } from '@mui/material';
import { lighten } from '@mui/material/styles';

const LIGHTEN = 0.9;
const LIGHTEN_HOVER = 0.85;

export const ListItemStyled = styled(ListItem)(({ theme }) => ({
  [`& .${listItemButtonClasses.root}`]: {
    [`&.${listItemButtonClasses.selected}`]: {
      backgroundColor: lighten(theme.palette.success.main, LIGHTEN),

      [`&:hover`]: {
        backgroundColor: lighten(theme.palette.success.main, LIGHTEN_HOVER),
      },
    },
  },
  [`& .${listItemIconClasses.root}`]: {
    minWidth: 40,
  },
}));
